import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { alignSelf, justifyContent, flex } from '../../styles/helpers/flexbox';

const TextInputComponent = styled.div`
display: inherit;
position: relative;
`;

const InputWrapper = styled.input((props) => {
    const { colours, typography } = ThemeHelper.getTheme(props);

    return `
        width: 100%;    
        height: 23px;
        padding: 8px 22px;
        border: 1px solid ${colours.grey[200]};
        border-radius: 5px;
        font-family: ${typography.family};
        font-size: 15px;
        outline: none;

        &::-webkit-input-placeholder {
            color: lightgray;
            font-size: 15px;
        }

        &:-ms-input-placeholder {
            color: lightgray;
            font-size: 15px;
        }
    `;
});

const ClearButton = styled.button((props) => {
    const { colours } = ThemeHelper.getTheme(props);

    return `
        @include ${alignSelf('center')}
        @include ${justifyContent('center')}
        @include ${flex('none')}
    
        position: absolute;
        right: 0;
        top: 50%;
        background-color: ${colours.grey[400]};
        height: 20px;
        width: 20px;
        margin: -10px 5px 5px;
        border-radius: 100%;
        border: 0;
        outline: none;
        font-size: 10px;
    
        & > div {
            height: 100%;
        }
    `;
});
export { ClearButton, TextInputComponent, InputWrapper };



// WEBPACK FOOTER //
// ./app/components/text-input/styled.js